// src/pages/StorePage.js
import React, { useState, useEffect } from 'react';
import { getProducts, getPublicStore } from '../api/apiService';
import ProductCard from '../components/ProductCard';

const StorePage = ({ onProductClick }) => {
  const [products, setProducts] = useState([]);
  const [store,    setStore]    = useState(null);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        // FIX: obtener la tienda pública desde la BD, no desde localStorage
        const publicStore = await getPublicStore();
        if (!mounted) return;

        if (!publicStore) {
          setStore(null);
          setProducts([]);
          setLoading(false);
          return;
        }

        setStore(publicStore);
        const sid = String(publicStore.id);
        const all = await getProducts();
        if (!mounted) return;

        const filtered = all.filter(p =>
          Array.isArray(p.assignedStores) &&
          p.assignedStores.map(String).includes(sid)
        );
        setProducts(filtered);
      } catch (err) {
        console.error('Error cargando tienda:', err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <section id="store-section" style={{ padding: '64px 24px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px,1fr))', gap: '16px' }}>
            {[...Array(4)].map((_, i) => (
              <div key={i} style={{ background: '#f5f2f2', height: '320px',
                borderRadius: '2px', animation: 'pulse 1.5s infinite' }} />
            ))}
          </div>
        </div>
        <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.5} }`}</style>
      </section>
    );
  }

  if (!store) {
    return (
      <section id="store-section" style={{ padding: '48px 24px', textAlign: 'center' }}>
        <p style={{ fontFamily: "'Montserrat', sans-serif", color: '#bbb', fontSize: '13px' }}>
          Selecciona una tienda pública para ver productos.
        </p>
      </section>
    );
  }

  if (products.length === 0) {
    return (
      <section id="store-section" style={{ padding: '48px 24px', textAlign: 'center' }}>
        <p style={{ fontFamily: "'Montserrat', sans-serif", color: '#bbb', fontSize: '13px' }}>
          No hay productos disponibles en esta tienda.
        </p>
      </section>
    );
  }

  return (
    <section id="store-section" style={{ padding: 'clamp(48px,6vw,80px) 24px', background: 'white' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <p style={{ fontFamily: "'Montserrat', sans-serif", color: '#961914',
            fontSize: '10px', letterSpacing: '0.38em', textTransform: 'uppercase',
            marginBottom: '10px', fontWeight: 600 }}>
            Boutique
          </p>
          <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 400,
            color: '#060D14', margin: '0 0 8px' }}>
            Nuestra Tienda
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '10px' }}>
            <div style={{ height: '1px', width: '36px', background: '#e5c9c9' }} />
            <div style={{ width: '4px', height: '4px', borderRadius: '50%',
              background: '#961914' }} />
            <div style={{ height: '1px', width: '36px', background: '#e5c9c9' }} />
          </div>
        </div>
        <div style={{ display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '20px' }}>
          {products.map(product => (
            <ProductCard key={product.id} product={product} onProductClick={onProductClick} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StorePage;
